import React from 'react';
import styled from 'styled-components';
import { Bio } from '../../data/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCode } from '@fortawesome/free-solid-svg-icons';

import instagram from "../../images/instagram-logo.svg";
import { Title } from '../Skills';

const FooterContainer = styled.div`
  width: 100%;
  padding: 2rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-around;
  }
`;

const FooterWrapperContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  
  

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-around;
    width: 100%;
  }
`;

const FooterWrapper = styled.footer`
  display: flex;
  flex-direction: column;
  align-items: left;
  
  padding: 1rem;
  
  color: ${({ theme }) => theme.text_primary};


`;
const FooterWrapper2 = styled.footer`
  display: flex;
  flex-direction: column;
  align-items: center;
  
  padding: 1rem;
  
  color: ${({ theme }) => theme.text_primary};


`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  font-weight: 700; /* Bold the logo text */
  font-size: 24px; /* Make the logo slightly larger */
  color: ${({ theme }) => theme.primary};
  margin-bottom: 1rem; /* Add bottom margin to logo */
`;

const LogoText = styled.span`
  margin-left: 1em;
  color: white;
  text-align: center;
`;

const ContactImg = styled.img`
  width: 2em;
  height: 2em;
  margin-right: 0.5em; /* Add margin-right for spacing */
`;

const Copyright = styled.p`
  font-size: 1rem; /* Make the text slightly larger */
  font-weight: 500; /* Improve font weight for better readability */
  color: ${({ theme }) => theme.soft2};
  text-align: center;
  margin-bottom: 2rem; /* Add bottom margin for spacing */

  @media (min-width: 768px) {
    text-align: left;
    margin-bottom: 0;
  }
`;

const ContactTable = styled.table`
  text-align: left;
  margin-top: 1rem;
  td {
    padding: 0.3rem 0;
    font-size: 1.1rem;
    font-weight: 400;
    color: white;
  }
  a {
    color: white;
    text-decoration: underline;
    font-weight: 600;
    margin-left: 0.5rem;

    @media (max-width:320px){
      font-size : 0.55em;
    }
  }
    
`;

const GithubLogo = styled.a`
  svg {
    fill: ${({ theme }) => theme.text_primary};
    transition: fill 0.2s ease-in-out, transform 0.4s cubic-bezier(0.165, 0.84, 0.44, 1) 0.1s;
    height: 25px;
    width: 25px;
    margin-right: 15px;
    transform-origin: center;
  }

  &:hover {
    svg {
      fill: ${({ theme }) => theme.primary};
      transform: scale(1.1);
    }
  }
`;

const LinkdinLogo = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;
  margin-bottom: 1.5rem; /* Add bottom margin for spacing */

  svg {
    fill: ${({ theme }) => theme.text_primary};
    transition: fill 0.2s ease-in-out, transform 0.4s cubic-bezier(0.165, 0.84, 0.44, 1) 0.1s;
    height: 25px;
    width: 25px;
    margin-right: 15px;
    transform-origin: center;
  }

  &:hover {
    svg {
      fill: ${({ theme }) => theme.primary};
      transform: scale(1.1);
    }
  }

  span {
    font-weight: 600; 
    color: white; 
  }
`;


const Iframe = styled.iframe`
  border: none;
  border-radius: 1em;
  width: 90%; /* Default for mobile */

  @media (min-width: 768px) {
    width: 400px;
    height: 300px;
  }
`;

const Footer = () => {
  return (
    <>
      <Title>Contact Us</Title>
      <FooterContainer>
        <FooterWrapperContainer>
          <FooterWrapper>
            
            <Logo>
              <FontAwesomeIcon icon={faCode} className="icon" />
              <LogoText>Nirman'24 <span style={{ fontSize: "0.6em" }}>by ORCES</span></LogoText>
            </Logo>

            <LinkdinLogo href="https://instagram.com/orces_itnu" target="_blank">
              <ContactImg src={instagram} />
              <span>Orces</span>
            </LinkdinLogo>

            <LinkdinLogo href={Bio.linkedin} target="_blank">
              <ContactImg src={instagram} />
              <span>Nirman</span>
            </LinkdinLogo>

            <Copyright>
              <ContactTable>
                <tr>
                  <td>Lakshya Bhatiya:</td>
                  <td>
                    <a href="tel:+917427813679">+91 7427813679</a>
                  </td>
                </tr>
                <tr>
                  <td>Shreyansh Shah:</td>
                  <td>
                    <a href="tel:+918160209185">+91 8160209185</a>
                  </td>
                </tr>
                <tr>
                  <td>Bhavy Samar:</td>
                  <td>
                    <a href="tel:+919351445203">+91 9351445203</a>
                  </td>
                </tr>
              </ContactTable>
            </Copyright>
          </FooterWrapper>
        </FooterWrapperContainer>
        
        
        <FooterWrapperContainer>
          <FooterWrapper2>
            <Iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3669.1365350613437!2d72.54286747532475!3d23.128684112359984!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e832f45125167%3A0x876cb1cb23c25bdb!2sNirma%20University!5e0!3m2!1sen!2sin!4v1725047588825!5m2!1sen!2sin" 
              width="400" height="300"
              loading="lazy" 
              referrerpolicy="no-referrer-when-downgrade"
            ></Iframe>
          </FooterWrapper2>
        </FooterWrapperContainer>

        
      </FooterContainer>
    </>
  );
};

export default Footer;
